// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import { Feature } from '@fulcrumapp/fulcrum-core';
import Immutable from 'immutable';
import MapView from '../../data-view/map/map-view';
import { AppContext } from '../../hooks/use-app';

import Track from './track';

const DEFAULT_ZOOM = 17;

export default class TrackMapView extends React.Component {
  static propTypes = {
    className: PropTypes.string.isRequired,
    // item: PropTypes.insmaptanceOf(MediaItemValue).isRequired,
    feature: PropTypes.instanceOf(Feature),
    visible: PropTypes.bool.isRequired,
    // metadata: PropTypes.instanceOf(Object),
    track: PropTypes.instanceOf(Track),
    currentPoint: PropTypes.instanceOf(Object),
    onTrackClick: PropTypes.func.isRequired,
  };

  static contextType = AppContext;

  renderNoTrack() {
    const { styles } = TrackMapView;

    if (this.props.visible && this.props.currentPoint == null) {
      return (
        <div className={styles.noTrack}>
          There is no track information for the current position in the file.
        </div>
      );
    }

    return null;
  }

  render() {
    const { styles } = TrackMapView;

    const circles = [];

    if (this.props.feature && this.props.feature.hasCoordinate) {
      circles.push({
        data: { feature: this.props.feature, parent: true },
        color: '#3F51B5',
        location: { lat: this.props.feature.latitude, lng: this.props.feature.longitude },
      });
    }

    let currentViewPoint = null;

    if (this.props.currentPoint) {
      const DEBUG = false;

      if (DEBUG) {
        if (this.props.currentPoint.prev) {
          circles.push({
            data: { point: this.props.currentPoint.prev },
            color: '#00ff00',
            location: { lat: this.props.currentPoint.prev.latitude, lng: this.props.currentPoint.prev.longitude },
          });
        }

        if (this.props.currentPoint.next) {
          circles.push({
            data: { point: this.props.currentPoint.next },
            color: '#00ff00',
            location: { lat: this.props.currentPoint.next.latitude, lng: this.props.currentPoint.next.longitude },
          });
        }
      }

      if (this.props.currentPoint.course != null || this.props.currentPoint.viewport != null) {
        const [lat, lng] = this.props.currentPoint.location;

        currentViewPoint = {
          location: { lat, lng },
        };

        if (this.props.currentPoint.course != null) {
          currentViewPoint.courseAngle = this.props.currentPoint.course;
        }

        if (this.props.currentPoint.viewport != null) {
          currentViewPoint.viewportAngle = this.props.currentPoint.viewport;
        }
      }
    }

    const circleMarkers = new Immutable.List(Immutable.fromJS(circles));

    const geojson = this.props.track ? this.props.track.toGeoJSONSegments()
      : null;

    const lines = geojson ? new Immutable.List([geojson]) : null;

    return (
      <div className={cx(this.props.className, styles.container)}>
        <MapView
          ref={this.bindMapView}
          className={styles.map}
          visible={this.props.visible}
          parentView="media-viewer"
          lines={lines}
          onTrackLineClick={this.handleLineClick}
          center={this.props.currentPoint && this.props.currentPoint.location}
          zoom={DEFAULT_ZOOM}
          circleMarkers={circleMarkers}
          currentViewPoint={currentViewPoint}
          showExtentsControl={false}
          showGeocoderControl={false}
        />
        {this.renderNoTrack()}
      </div>
    );
  }

  handleLineClick = (time) => {
    this.props.onTrackClick(time);
  };

  bindMapView = (node) => {
    this.mapView = node;
  };
}

const styles = cssInJS({
  container: {
    borderLeft: '1px solid #aaa',

    '@phone': {
      borderLeft: 'none',
      borderTop: '1px solid #d9d9d9',
      borderBottom: '1px solid #d9d9d9',
    },
  },

  map: {
    width: '100%',
    height: '100%',
  },

  noTrack: {
    position: 'absolute',
    left: '50%',
    top: 0,
    marginLeft: -125,
    width: 250,
    backgroundColor: '#fff',
    fontSize: 13,
    textAlign: 'center',
    padding: 8,
    borderBottomRightRadius: 3,
    borderBottomLeftRadius: 3,
    fontFamily: THEME.fontFamily,
  },
});

TrackMapView.styles = styles;
